import { render, staticRenderFns } from "./ordersDone.vue?vue&type=template&id=249fb068"
import script from "./ordersDone.vue?vue&type=script&lang=js"
export * from "./ordersDone.vue?vue&type=script&lang=js"
import style0 from "./ordersDone.vue?vue&type=style&index=0&id=249fb068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports